/**
 * The page's own scroller, under the top bar: every page brings one, and
 * the window itself never scrolls. The router puts it at the top on the way
 * to a page, and back where it was on the way back.
 */
export const pageScroller = () => document.querySelector('#main > :is(.shpage, .xpage, .setpage, .scroll)');

/** Back to the top of the page you are on. */
export function scrollPageToTop() {
  pageScroller()?.scrollTo({ top: 0 });
}
